import { Button } from "../../button";

import "./pagination.css";

type CursorPaginationProps = {
    hasNext: boolean;
    hasPrevious: boolean;
    currentPage: number;
    fetchPreviousPage: () => void;
    fetchNextPage: () => void;
}

export function CursorPagination({
    hasNext,
    hasPrevious,
    fetchPreviousPage,
    fetchNextPage,
}: CursorPaginationProps) {
    return (
        <div className="table-pagination">
            <Button labelKey="previous" variant="primary" onClick={fetchPreviousPage} disabled={!hasPrevious} />
            <Button labelKey="next" variant="primary" onClick={fetchNextPage} disabled={!hasNext} />
        </div>
    );
}